<template>
  <div class="digital_newspaper_of_internet">
    <div v-title :data-title="title"></div>
    <div class="header">
      <img class="header_image" :src="headerImage" />
      <div class="header_content">
        <div class="header_left">
          <img :src="logo" alt="" />
        </div>
        <div class="header_right">
          <button @click="newspaperSearch()" v-if="isInlineIP">报纸检索</button>
          <button @click="goBackHomePage()">返回首页</button>
        </div>
      </div>
    </div>
    <div class="body" v-if="allPageList">
      <div class="left">
        <div class="layout">
          <digitalNewspaperLayout
            :imgSrc="imgsAddress + curNewspaperPage.jpgPath"
            :areaMapList="layoutDetailList"
            v-if="layoutDetailList"
            @click="showArticleDetailFun"
            :articleIndex.sync="articleListIndex"
          ></digitalNewspaperLayout>
        </div>
        <div class="cur_page_info_box" v-if="showArticleDetail">
          <div class="cur_page_info">
            <span
              ><strong>当前版：</strong>第{{
                curNewspaperPage.edition
              }}版：<strong>{{ curNewspaperPage.editionName }}</strong></span
            >
          </div>
          <div class="switch_page">
            <span
              class="pre"
              @click="preOrNextPage(-1)"
              :class="{ disabled: curPageIndex < 1 }"
              >[上一版]</span
            >
            <span
              class="next"
              @click="preOrNextPage(1)"
              :class="{ disabled: curPageIndex > allPageList.length - 2 }"
              >[下一版]
            </span>
            <img
              v-if="isInlineIP"
              src="../../../../public/image/downloadPdf.png"
              alt=""
              @click="downloadFile(curNewspaperPage.pdfPath)"
            />
          </div>
        </div>
        <div class="article_list" v-if="showArticleDetail">
          <articleList
            :articleList="layoutDetailList"
            v-if="layoutDetailList"
            @showArticleDetail="showArticleDetailFun"
            :articleIndex.sync="articleListIndex"
          ></articleList>
        </div>
      </div>
      <div class="right">
        <div class="pattern_list" v-if="!showArticleDetail">
          <div class="article">
            <span class="pub_time">{{
              formatDate1(curNewspaperPage.publishTime)
            }}</span>
            <div
              class="more_paper"
              v-if="morePaperList.length > 0"
              v-tooltip
              :template="true"
              theme="more_paper_tooltip_div"
            >
              <span>更多报种>></span>
              <div class="tooltip_templates">
                <ul class="more_paper_ul">
                  <li
                    :key="index"
                    class="more_paper_li"
                    v-for="(paper, index) in morePaperList"
                    @click="changePaper(paper)"
                  >
                    <img
                      :src="morePaperaddressPrefix + paper.digitalNewspaperLogo"
                      alt=""
                    />
                  </li>
                </ul>
              </div>
            </div>
            <div class="cur_page_info_box">
              <div class="cur_page_info">
                <span
                  >第{{ curNewspaperPage.edition }}版：<strong>{{
                    curNewspaperPage.editionName
                  }}</strong></span
                >
                <img
                  v-if="isInlineIP"
                  src="../../../../public/image/downloadPdf.png"
                  alt=""
                  @click="downloadFile(curNewspaperPage.pdfPath)"
                />
              </div>
              <div class="switch_page">
                <span
                  class="pre"
                  @click="preOrNextPage(-1)"
                  :class="{ disabled: curPageIndex < 1 }"
                >
                  <<上一版</span
                >
                <span
                  @click="preOrNextPage(1)"
                  :class="{ disabled: curPageIndex > allPageList.length - 2 }"
                  >下一版>>
                </span>
              </div>
            </div>
            <div class="article_list">
              <ul>
                <li
                  :key="index"
                  v-for="(item, index) in layoutDetailList"
                  v-text="item.documentTitle"
                  @click="showArticleDetailFun(item, index)"
                ></li>
              </ul>
            </div>
          </div>
          <div class="pages">
            <div class="date">
              <datepicker
                ref="datepicker1"
                :disabled-dates="disabledDates1"
                v-model="publishTime"
                @input="changeDate"
                format="yyyy-MM-dd"
                :language="languages.zh"
                @changedMonth="changedMonth"
              ></datepicker>
              <img
                src="../../../../public/image/datepicker.png"
                alt=""
                class="date_font"
                @click="openDatepicker"
              />
            </div>
            <div class="btns">
              <button
                @click="showPreOrNextNewspaper(0)"
                :class="{ disabled: !hasPrev }"
              >
                上一期
              </button>
              <button
                @click="showPreOrNextNewspaper(1)"
                :class="{ disabled: !hasNext }"
              >
                下一期
              </button>
            </div>
            <div class="newspaper_page_list">
              <newspaperPageList
                :pagesList="allPageList"
                v-if="allPageList"
                :curPageIndex.sync="curPageIndex"
                :curPage.sync="curNewspaperPage"
                @choosePage="choosePage"
                :isInline="isInlineIP"
              ></newspaperPageList>
            </div>
          </div>
        </div>
        <div class="pattern_detail" v-if="showArticleDetail">
          <div class="detail_top">
            <div class="detail_top_left">
              <span class="pub_time">{{
                formatDate1(curNewspaperPage.publishTime)
              }}</span>
              <div
                class="more_paper"
                v-if="morePaperList.length > 0"
                v-tooltip
                :template="true"
                theme="more_paper_tooltip_div"
              >
                <span>更多报种>></span>
                <div class="tooltip_templates">
                  <ul class="more_paper_ul">
                    <li
                      :key="index"
                      class="more_paper_li"
                      v-for="(paper, index) in morePaperList"
                      @click="changePaper(paper)"
                    >
                      <img
                        :src="
                          morePaperaddressPrefix + paper.digitalNewspaperLogo
                        "
                        alt=""
                      />
                    </li>
                  </ul>
                </div>
              </div>
              <p class="piece">
                <span
                  @click="showPreOrNextArticle(-1)"
                  :class="{ disabled: articleListIndex < 1 }"
                  >[上一篇]</span
                >
                <span
                  @click="showPreOrNextArticle(1)"
                  :class="{
                    disabled: articleListIndex > layoutDetailList.length - 2,
                  }"
                  >[下一篇]</span
                >
              </p>
            </div>
            <div class="fr">
              <div class="detail_top_middle">
                <span class="date">
                  <datepicker
                    ref="datepicker2"
                    :disabled-dates="disabledDates2"
                    v-model="publishTime"
                    @input="changeDate"
                    format="yyyy-MM-dd"
                    :language="languages.zh"
                    @changedMonth="changedMonth"
                  ></datepicker>
                  <img
                    src="../../../../public/image/datepicker.png"
                    alt=""
                    class="date_font"
                    @click="openDatepicker"
                  />
                </span>
              </div>
              <div class="detail_top_right">
                <button
                  @click="showPreOrNextNewspaper(0)"
                  :class="{ disabled: !hasPrev }"
                >
                  上一期
                </button>
                <button
                  @click="showPreOrNextNewspaper(1)"
                  :class="{ disabled: !hasNext }"
                >
                  下一期
                </button>
                <p class="back_to_list" @click="goBack()">返回版面列表</p>
              </div>
            </div>
          </div>
          <div class="article_detail_box">
            <articleDetail
              :article="selectedArticle"
              v-if="selectedArticle"
              :articleImgs="articleImg"
              :articleAddressPreFix="articleImgAddress"
            ></articleDetail>
          </div>
        </div>
      </div>
      <div class="all_paper_list">
        <ul>
          <li
            class="all_paper_li"
            :key="index"
            v-for="(item, index) in morePaperList"
            @click="changePaper(item)"
          >
            <img
              :src="morePaperaddressPrefix + item.digitalNewspaperLogo"
              alt=""
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <p v-text="signature"></p>
    </div>
  </div>
</template>
<script>
import digitalNewspaperLayout from "./components/digitalNewspaperLayout.vue";
import newspaperPageList from "./components/newspaperPageList.vue";
import articleList from "./components/articleList.vue";
import articleDetail from "./components/articleDetail.vue";
import * as lang from "vuejs-datepicker/dist/locale/index.js";
export default {
  nama: "newspaperOfPc",
  components: {
    digitalNewspaperLayout,
    newspaperPageList,
    articleList,
    articleDetail,
  },
  data() {
    let route = this.$route;
    let self = this;
    return {
      curNewspaperPage: "", //当前的报纸版面
      allPageList: "", // 所有的报纸版面
      imgsAddress: "", //图片访问地址前缀
      layoutDetailList: "", //详情列表
      logo: "",
      headerImage: "",
      signature: "",
      publishTime: route.query.publishTime, //报纸发布时间
      languages: lang,
      hasDataDates: [],
      disabledDates1: {
        //禁止选中的日期
        customPredictor(date) {
          if (self.$refs.datepicker1 && !self.$refs.datepicker1.showDayView) {
            return false;
          }
          let date_ = self.formatDate(date, "yyyy-MM-dd") + " 00:00:00";
          return (
            date > new Date() ||
            (self.hasDataDates.length > 0 && !self.hasDataDates.includes(date_))
          );
        },
      },
      disabledDates2: {
        //禁止选中的日期
        customPredictor(date) {
          if (self.$refs.datepicker2 && !self.$refs.datepicker2.showDayView) {
            return false;
          }
          let date_ = self.formatDate(date, "yyyy-MM-dd") + " 00:00:00";
          return (
            date > new Date() ||
            (self.hasDataDates.length > 0 && !self.hasDataDates.includes(date_))
          );
        },
      },
      selectedArticle: "", // 选中的文章
      showArticleDetail: false, //是否展示详情
      articleListIndex: "", //文章索引
      curPageIndex: "", //当前版面索引
      today: this.formatDate(Date(), "yyyy-MM-dd"),
      mediaKey: route.query.mediaKey,
      digitalNewspaperName: "",
      title: "",
      isInlineIP: false,
      articleImg: "", //文章详情中的图片
      articleImgAddress: "", //文章详情里的图片访问前缀
      morePaperList: "", // 更多报种列表
      morePaperaddressPrefix: "", //更多报种的图片访问前缀
      classify: Number(route.query.classify), //分类--0:日报 1:区县
      tenantId: route.query.tenantId,
      hasNext: false, //是否有下一期
      hasPrev: false, //是否有上一期
    };
  },
  computed:{
    curEdition(){
      return isNaN(this.$route.query.curEdition)?'01':this.$route.query.curEdition
    }
  },
  mounted() {
    this.initFun();
  },
  methods: {
    /**
     * @[getHasDataDates description] 获取当前月有数据的日期
     * @param {*} date
     * @return {*} [desc] 返回前后30天有数据的日期
     */
    getHasDataDates(date) {
      let _date = this.formatDate(date, "yyyy-MM-dd") + " 00:00:00";
      return new Promise((resolve) => {
        this.post("/digitalNewspaper/web/layout/findHasDataDate", {
          digitalNewspaperMediaId: this.$route.query.id,
          currentTime: _date,
        }).then((res) => {
          this.hasDataDates = [...new Set([...this.hasDataDates, ...res.msg])];
          resolve();
        });
      });
    },
    changedMonth(date) {
      let _date = this.formatDate(date, "yyyy-MM-dd");
      this.getHasDataDates(_date);
    },
    /**
     * [initFun description]初始化
     * @return {[type]} [description]
     */
    initFun() {
      let self = this;
      let isSearch = self.$route.query.isSearch; //是否是由检索页面跳转过来的
      if (self.publishTime) {
        self.getHasDataDates(self.publishTime);
        if (isSearch||self.$route.query.showArticleDetail=== 'true') {
          self.publishTime = self.formatDate(self.publishTime, "yyyy-MM-dd");
          self.getNewspaperPageListByTimeAndMedia().then(() => {
            self.curNewspaperPage = self.allPageList.find((item) => {
              return Number(item.edition) == Number(self.curEdition);
            });
            self.curPageIndex = self.allPageList.findIndex((item) => {
              return Number(item.edition) == Number(self.curEdition);
            });
            self.getNewspaperPageDetail(self.curNewspaperPage).then(() => {
              self.articleListIndex = self.layoutDetailList.findIndex(
                (item) => {
                  return item.layoutDetailId == self.$route.query.docId;
                }
              );
              self.requestArticleDetail(
                self.layoutDetailList[self.articleListIndex]
              );
              self.showArticleDetail = true;
            });
          });
        } else {
          self.getNewspaperPageListByTimeAndMedia().then(() => {
            if (self.curEdition){
                self.curNewspaperPage = self.allPageList.find((item) => {
                  return Number(item.edition) == Number(self.curEdition);
                });
                self.curPageIndex = self.allPageList.findIndex((item) => {
                  return Number(item.edition) == Number(self.curEdition);
                });
            }
            self.getNewspaperPageDetail(self.curNewspaperPage);
          });
        }
      } else {
        self.getFirstNewspaperPageList().then(() => {
          self.getNewspaperPageDetail(self.curNewspaperPage).then(() =>{
            if (self.$route.query.showArticleDetail==='true'){
                self.articleListIndex = self.layoutDetailList.findIndex(
                (item) => {
                  return item.layoutDetailId == self.$route.query.docId;
                }
              );
              self.requestArticleDetail(
                self.layoutDetailList[self.articleListIndex]
              );
              self.showArticleDetail = true;
            }
          });
        });
      }
      self.getMediaLogoAndSignature();
      self.checkIPStatus();
      self.getMorePaperList();
    },
    //判断是否是内网IP
    checkIPStatus() {
      let self = this;
      let params = {};
      if (typeof self.tenantId != "undefined") {
        params.tenantId = self.tenantId;
      }
      this.post(
        "/digitalNewspaper/web/ipConfiguration/getIpStatus",
        params
      ).then((res) => {
        if (res.status == "success") {
          self.isInlineIP = res.ipStatus;
        }
      });
    },
    /**
     * [getPaperList 获取更多报种列表
     * @return {[type]} [description]
     */
    getMorePaperList() {
      let self = this;
      let params = {
        digitalNewspaperMark: this.mediaKey,
        classify: this.classify,
      };
      self
        .post(
          "/digitalNewspaper/web/digitalNewspaperMedia/findListOther",
          params
        )
        .then((data) => {
          try {
            self.morePaperList = data.msg;
            self.morePaperaddressPrefix = data.addressPrefix;
          } catch (error) {
            console.log("获取数字报列表失败", error);
          }
        });
    },
    /**
     * [changePaper description]切换报种
     * @return {[type]} [description]
     */
    changePaper(item) {
      let self = this;
      self.mediaKey = item.digitalNewspaperMark;
      self.getMediaLogoAndSignature();
      self.checkIPStatus();
      self.publishTime = self.formatDate(self.publishTime, "yyyy-MM-dd");
      self.getNewspaperPageListByTimeAndMedia().then(() => {
        self.getNewspaperPageDetail(self.curNewspaperPage);
        self.goBack();
      });
      self.getMorePaperList();
      //路由切换，记住当前地址
      this.$router.push({
        name: "newspaperContent",
        query: {
          mediaKey: item.digitalNewspaperMark,
          publishTime: self.publishTime,
          classify: self.classify,
          id: item.digitalNewspaperMediaId,
        },
      });
    },
    /**
     * [getFirstNewspaperPageList description]获取首版
     * @return {[type]} [description]
     */
    getFirstNewspaperPageList() {
      return new Promise((resolve, reject) => {
        let self = this;
        let params = {
          digitalNewspaperMark: self.mediaKey ? self.mediaKey : "wzrb",
        };
        self
          .post(
            "/digitalNewspaper/web/layoutCatalog/listByDigitalNewspaperMark",
            params
          )
          .then(
            (resp) => {
              try {
                self.allPageList = resp.msg;
                self.imgsAddress = resp.addressPrefix;                
                self.hasNext = resp.hasNext;
                self.hasPrev = resp.hasPrevious;
                self.curPageIndex = self.allPageList.findIndex(item=>{
                    return Number(item.edition) == Number(self.curEdition);
                });
                self.curNewspaperPage = self.allPageList[self.curPageIndex];
                self.publishTime = self.curNewspaperPage.publishTime;
                self.getHasDataDates(self.publishTime);
                resolve();
              } catch (e) {
                console.error(e);
                reject();
              }
            },
            (reject) => {
              this.$router.push({
                path: "/homePage",
              });
            }
          );
      });
    },
    /**
     * [getMediaLogoAndSignature description]获取网站签名和logo
     * @return {[type]} [description]
     */
    getMediaLogoAndSignature() {
      let self = this;
      let params = {
        digitalNewspaperMark: self.mediaKey ? self.mediaKey : "wzrb",
      };
      self
        .post(
          "/digitalNewspaper/web/digitalNewspaperMedia/findByDigitalNewspaperMark",
          params
        )
        .then((resp) => {
          try {
            self.logo = resp.digitalNewspaperLogo;
            self.signature = resp.signature;
            self.headerImage = resp.pageHeadImage;
            self.digitalNewspaperName = resp.digitalNewspaperName;
            self.title = self.digitalNewspaperName;
          } catch (e) {
            console.log(e);
          }
        });
    },
    /**
     * [getNewspaperPageDetail description]获取版面坐標及文章列表
     * @param  {[type]} curPage [description]当前版面
     * @return {[type]}         [description]
     */
    getNewspaperPageDetail(curPage) {
      let self = this;
      return new Promise((resolve) => {
        let params = {
          layoutCatalogId: curPage.layoutCatalogId,
        };
        self
          .post(
            "/digitalNewspaper/web/layoutDetail/listByLayoutCatalogId",
            params
          )
          .then((resp) => {
            self.layoutDetailList = resp.msg;
            resolve();
          });
      });
    },
    /**
     * [changeDate description]切换日期
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    changeDate(e) {
      this.publishTime = this.formatDate(this.publishTime, "yyyy-MM-dd");
      this.$router.replace({
        //选择日期后将选中的日期记录在路由上，刷新页面时将会获取到选中日期的报纸
        path: "/newspaper",
        query: {
          ...this.$route.query,
          publishTime: this.publishTime,
        },
      });
      this.getNewspaperPageListByTimeAndMedia().then(() => {
        this.getNewspaperPageDetail(this.curNewspaperPage);
      });
      this.showArticleDetail = false;
    },
    /**
     * [openDatepicker description]展开日期控件
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    openDatepicker(e) {
      let $img = $(e.currentTarget);
      $img.prev().find("input")[0].click();
      $img.prev().find("input")[0].focus();
    },
    /**
     * [showArticleDetailFun description]展示文章详情
     * @return {[type]} [description]
     */
    showArticleDetailFun(data, index) {
      let self = this;
      self.showArticleDetail = true;
      this.requestArticleDetail(data);
      self.articleListIndex = index;
      self.curNewspaperPage;
      let query = this.$route.query;
      this.$router.replace({
        query: {
            ...query,
            showArticleDetail:true,  //是否展示文章详情
            docId:data.layoutDetailId,  //选中文章的id
            curEdition:self.curNewspaperPage.edition //当前选中的版面id
        }
      });
    },
    /**
     * [requestArticleDetail description]通過文章id获取文章详情
     * @param  {[type]} articleId [description]
     * @return {[type]}           [description]
     */
    requestArticleDetail(article) {
      let self = this;
      this.title = article.documentTitle;
      let params = {
        layoutDetailId: article.layoutDetailId,
        pictureDetail: article.pictureDetail,
      };
      self
        .post("/digitalNewspaper/web/layoutDetail/findByLayoutDetailId", params)
        .then((resp) => {
          try {
            self.selectedArticle = resp.msg;
            self.selectedArticle.publishTime = this.formatDate(
              resp.msg.publishTime,
              "yyyy-MM-dd"
            );
            self.articleImg = resp.layoutPictures;
            self.articleImgAddress = resp.addressPrefix;
          } catch (e) {}
        });
    },
    /**
     * [showPreOrNextArticle description]展示上一篇/下一篇文章
     * @param  {[type]} unmber [description]
     * @return {[type]}        [description]
     */
    showPreOrNextArticle(unmber) {
      let self = this;
      if (
        (unmber === -1 && self.articleListIndex === 0) ||
        (unmber === 1 &&
          self.articleListIndex === self.layoutDetailList.length - 1)
      ) {
        return;
      }
      self.articleListIndex += unmber;
      //self.selectedArticle = self.layoutDetailList[self.articleListIndex];
      self.requestArticleDetail(self.layoutDetailList[self.articleListIndex]);
    },
    /**
     * [goBack description]返回
     * @return {[type]} [description]
     */
    goBack() {
      this.showArticleDetail = false;
      this.title = this.digitalNewspaperName;
      let query = this.$route.query;
      this.$router.replace({
        query:{
            ...query,
            showArticleDetail:false
        }
      });
    },
    goBackHomePage() {
      this.title = "温州日报报业集团数字报纸";
      this.$router.push({
        path: "/homePage",
      });
    },
    /**
     * [prePage description]获取上一版/下一版
     * @param  {[type]} number [description]
     * @return {[type]}        [description]
     */
    preOrNextPage(number) {
      let self = this;
      if (
        (number === -1 && self.curPageIndex === 0) ||
        (number === 1 && self.curPageIndex == self.allPageList.length - 1)
      )
        return;
      this.title = this.digitalNewspaperName;
      self.curPageIndex += number;
      self.curNewspaperPage = self.allPageList[self.curPageIndex];
      self.showArticleDetail = false;
      self.getNewspaperPageDetail(self.curNewspaperPage);
      let query = this.$route.query;
      self.$router.replace({
        query:{
            ...query,
            curEdition:self.curPageIndex+1,
            showArticleDetail:false
        }
      });
    },

    /**
     * [choosePage description]选中版面
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    choosePage() {
      let self = this;
      self.getNewspaperPageDetail(self.curNewspaperPage);
    },
    /**
     * [downloadFile description]文件下载
     * @param  {[type]} filePath [description]
     * @return {[type]}          [description]
     */
    downloadFile(filePath) {
      this.$downloadFile(filePath);
    },
    /**
     * [getNewspaperPageListByTimeAndMedia description]根据发布时间和媒体标识查询数字报
     * @return {[type]} [description]
     */
    getNewspaperPageListByTimeAndMedia() {
      return new Promise((resolve, reject) => {
        var self = this;
        let params = {
          digitalNewspaperMark: self.mediaKey,
          publishTime: self.publishTime,
        };
        self
          .post(
            "/digitalNewspaper/web/layoutCatalog/listByDigitalNewspaperMarkAndPublishTime",
            params
          )
          .then(
            (resp) => {
              self.allPageList = resp.msg;
              self.curNewspaperPage = resp.msg[0];
              self.imgsAddress = resp.addressPrefix;
              self.curPageIndex = 0;
              self.hasNext = resp.hasNext;
              self.hasPrev = resp.hasPrevious;
              resolve();
            },
            (reject) => {
              self.$ask({
                type: "error",
                showCancel: false,
                content: reject.msg,
                time: 1000,
              });
              self.getFirstNewspaperPageList().then(() => {
                self.getNewspaperPageDetail(self.curNewspaperPage).then(() => {
                  self.goBack();
                });
              });
            }
          );
      });
    },
    /**
     * [showPreOrNextNewspaper description]展示上一期/下一期
     * @param  {[type]} number [description]
     * @return {[type]}        [description]
     */
    showPreOrNextNewspaper(number) {
      let self = this;
      this.title = this.digitalNewspaperName;
      this.findNewspaper(number).then((publishTime) => {
        self.publishTime = self.formatDate(publishTime, "yyyy-MM-dd");
        self.$router.push({
          path: "/newspaper",
          query: {
            mediaKey: self.mediaKey,
            publishTime: self.publishTime,
            classify: self.classify,
            id: self.$route.query.id,
          },
        });
        self.getNewspaperPageListByTimeAndMedia().then(() => {
          self.getNewspaperPageDetail(self.curNewspaperPage);
        });
        self.showArticleDetail = false;
      });
    },
    /**
     * [findNewspaper description] 查找最近日期的报纸信息
     * @param  {[type]} number [description] 上一期（0） 下一期（1）
     * @return {[type]}        [description]
     */
    findNewspaper(number) {
      let self = this;
      return new Promise((resolve, reject) => {
        let params = {
          digitalNewspaperMark: self.mediaKey ? self.mediaKey : "wzrb",
          publishTime: self.formatDate(self.publishTime, "yyyy-MM-dd"),
          infoType: number,
        };
        self
          .post(
            "/digitalNewspaper/web/layout/findByDigitalNewspaperMarkAndPublishTime",
            params
          )
          .then(
            (resp) => {
              resolve(resp.msg.publishTime);
            },
            (error) => {
              reject();
            }
          );
      });
    },
    /**
     * [newspaperSearch description]跳转至报纸检索页面
     * @return {[type]} [description]
     */
    newspaperSearch() {
      let router = this.$router.resolve({
        path: "search",
      });
      window.open(router.href, "_blank");
    },
  },
};
</script>
<style scoped lang="less">
.more_paper_tooltip_div {
  .tooltipster-box {
    background: #eeeeee;
    border-radius: 3px;
    border: 2px solid #eeeeee;

    .tooltipster-content {
      .more_paper_ul {
        width: 210px;

        .more_paper_li {
          width: 100px;
          height: 40px;
          background: #fff;
          display: inline-block;
          margin-right: 10px;
          margin-bottom: 10px;

          &:nth-child(2n) {
            margin-right: 0;
          }

          img {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
        }
      }
    }
  }

  /deep/.tooltipster-arrow {
    .tooltipster-arrow-border {
      /* border-top-color: #EEEEEE !important;
            border-left-color: #EEEEEE !important;
            border-right-color: #EEEEEE !important; */
    }

    .tooltipster-arrow-background {
      /* border-top-color: #EEEEEE !important;
            border-left-color: #EEEEEE !important;
            border-right-color: #EEEEEE !important;
            top: 1px !important; */
    }
  }
}

.digital_newspaper_of_internet {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .header {
    width: 100%;
    height: 145px;
    box-sizing: border-box;
    position: relative;

    .header_content {
      width: 1200px;
      height: 100%;
      box-sizing: border-box;
      padding-top: 45px;
      padding-bottom: 29px;
      margin: 0 auto;
      position: relative;

      .header_left {
        display: inline-block;
        vertical-align: middle;
        position: absolute;
        left: 0;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .header_right {
        position: absolute;
        right: 0;
        display: inline-block;
        padding-top: 20px;

        button {
          font-size: 16px;
          width: 90px;
          height: 30px;
          line-height: 30px;
          margin-right: 10px;
        }
      }
    }

    .header_image {
      width: 100%;
      height: 100%;
      position: absolute;
    }
  }

  .body {
    margin-top: 15px;
    border: solid 1px #ebeff2;
    padding-bottom: 20px;
    width: 1200px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    min-height: calc(100% - 212px);
    box-sizing: border-box;

    .left {
      width: 387px;
      margin-top: 10px;
      margin-left: 10px;
      display: inline-block;
      vertical-align: top;

      .layout {
        height: 655px;
        width: 100%;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.13);
        border: 1px solid rgba(233, 236, 239, 1);

        img {
          width: 100%;
          height: 100%;
        }
      }

      .cur_page_info_box {
        margin-top: 17px;

        &::after {
          content: " ";
          display: block;
          clear: both;
        }

        .cur_page_info {
          display: inline-block;
          height: 22px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(42, 42, 42, 1);
          line-height: 22px;
          float: left;
        }

        .switch_page {
          display: inline-block;
          height: 22px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(42, 42, 42, 1);
          line-height: 22px;
          float: right;
          cursor: pointer;

          img {
            cursor: pointer;
          }

          span {
            &.disabled {
              opacity: 0.5;
              cursor: not-allowed;
            }
          }

          .pre {
            margin-right: 20px;
            vertical-align: top;
          }

          .next {
            margin-right: 6px;
            vertical-align: top;
          }
        }
      }

      .article_list {
        margin-top: 30px;
      }
    }

    .right {
      display: inline-block;
      width: 780px;
      margin-top: 15px;
      margin-left: 20px;

      .pattern_list {
        width: 100%;

        .article {
          width: 390px;
          display: inline-block;
          vertical-align: top;

          .cur_page_info_box {
            margin-top: 18px;

            &::after {
              content: " ";
              display: block;
              clear: both;
            }

            .cur_page_info {
              display: inline-block;
              height: 22px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(42, 42, 42, 1);
              line-height: 22px;
              float: left;

              img {
                vertical-align: top;
                margin-left: 4px;
                cursor: pointer;
              }
            }

            .switch_page {
              display: inline-block;
              height: 22px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(42, 42, 42, 1);
              line-height: 22px;
              float: right;
              cursor: pointer;

              img {
                cursor: pointer;
              }

              .pre {
                margin-right: 20px;
              }

              span {
                &.disabled {
                  opacity: 0.5;
                  cursor: not-allowed;
                }
              }
            }
          }

          .article_list {
            margin-top: 10px;
            border-top: 1px solid #ebeff2;
            padding-top: 16px;

            ul {
              li {
                font-size: 14px;
                font-weight: 400;
                color: rgba(62, 62, 62, 1);
                line-height: 20px;
                margin-bottom: 15px;
                cursor: pointer;
                padding-left: 15px;
                box-sizing: border-box;
                position: relative;

                &:before {
                  content: " ";
                  width: 4px;
                  height: 4px;
                  position: absolute;
                  left: 0;
                  border-radius: 50%;
                  background: #989897;
                  top: 8px;
                }
              }
            }
          }
        }

        .pages {
          width: 370px;
          display: inline-block;
          margin-left: 10px;

          .date {
            display: inline-block;
            width: 150px;
            height: 30px;
            box-shadow: 0px 2px 4px 0px rgba(189, 189, 189, 0.28);
            border-radius: 2px;
            border: 1px solid rgba(182, 201, 224, 1);

            /deep/.vdp-datepicker {
              width: 100px;
              display: inline-block;

              input {
                width: 100px;
                height: 27px;
                border: none;
              }
            }

            .date_font {
              display: inline-block;
              vertical-align: middle;
              margin-left: 20px;
              cursor: pointer;
            }
          }

          .btns {
            margin-left: 50px;
            height: 30px;
            display: inline-block;
            vertical-align: top;

            button {
              width: 75px;
              height: 30px;
              background: rgba(74, 144, 226, 1);
              border-radius: 3px;
              font-size: 14px;
              font-weight: 500;
              color: rgba(255, 255, 255, 1);
              line-height: 30px;
              text-align: center;

              &.disabled {
                opacity: 0.5;
                cursor: not-allowed;
              }

              &:first-child {
                margin-right: 15px;
              }
            }
          }

          .newspaper_page_list {
            margin-top: 16px;
          }
        }
      }

      .pub_time {
        height: 22px;
        font-size: 16px;
        font-weight: 600;
        color: #060606;
        line-height: 22px;
        text-align: left;
        display: inline-block;
        margin-top: 5px;
      }

      .more_paper {
        font-size: 16px;
        color: blue;
        margin-left: 135px;
        font-weight: 400;
        color: #80b0eb;
        cursor: pointer;
        display: inline-block;
        height: 22px;
        vertical-align: middle;
      }

      .pattern_detail {
        width: 760px;

        .detail_top {
          button {
            width: 75px;
            height: 30px;
            background: rgba(74, 144, 226, 1);
            border-radius: 3px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            line-height: 30px;
            text-align: center;
          }

          .detail_top_left {
            display: inline-block;
            vertical-align: top;

            .more_paper {
              margin-left: 100px;
            }

            .piece {
              margin-top: 20px;
              font-size: 16px;
              font-weight: 400;
              color: rgba(42, 42, 42, 1);
              line-height: 22px;

              span:first-child {
                margin-right: 22px;
              }

              span {
                cursor: pointer;

                &.disabled {
                  opacity: 0.5;
                  cursor: not-allowed;
                }
              }
            }
          }
          .fr {
            display: inline-block;
            vertical-align: top;
            float: right;
          }
          .detail_top_middle {
            margin-left: 45px;
            display: inline-block;
            vertical-align: top;

            .date {
              width: 150px;
              height: 30px;
              box-shadow: 0px 2px 4px 0px rgba(189, 189, 189, 0.28);
              border-radius: 2px;
              display: inline-block;
              vertical-align: top;
              border: 1px solid rgba(182, 201, 224, 1);

              /deep/.vdp-datepicker {
                width: 100px;
                display: inline-block;

                input {
                  width: 100px;
                  height: 27px;
                  border: none;
                }
              }

              .date_font {
                display: inline-block;
                vertical-align: middle;
                margin-left: 20px;
                cursor: pointer;
              }
            }
          }

          .detail_top_right {
            display: inline-block;
            margin-left: 40px;

            button:first-child {
              margin-right: 15px;
            }

            button {
              &.disabled {
                opacity: 0.5;
                cursor: not-allowed;
              }
            }

            .back_to_list {
              margin-top: 22px;
              text-align: right;
              cursor: pointer;
              font-size: 16px;
            }
          }
        }

        .article_detail_box {
          margin-top: 20px;
          border-top: solid 1px #cccccc;
          padding-top: 27px;
        }
      }
    }

    .all_paper_list {
      margin: 20px;
      border-top: solid 1px #edf1f3;
      border-bottom: solid 1px #edf1f3;

      .all_paper_li {
        width: 200px;
        height: 90px;
        line-height: 110px;
        position: relative;
        display: inline-block;
        text-align: center;
        cursor: pointer;

        &:after {
          content: " ";
          position: absolute;
          top: 30px;
          right: 0;
          width: 1px;
          height: 30px;
          background: #edf1f3;
        }

        img {
          height: 30px;
        }
      }
    }
  }

  .footer {
    width: 100%;
    height: 58px;
    line-height: 58px;
    text-align: center;
  }
}
@media screen and(max-width:1200px) and (min-width: 980px) {
  .digital_newspaper_of_internet {
    .header {
      .header_content {
        width: 100%;
        .header_left {
          left: 20px;
        }
      }
    }
    .body {
      width: 100%;
      .right {
        width: calc(100% - 430px);
        .pattern_list {
          .article {
            width: 100%;
          }
          .pages {
            width: 100%;
          }
        }
        .pattern_detail {
          width: 100%;
          .detail_top {
            .detail_top_left {
              .more_paper {
                margin-left: 10px;
              }
            }
            .fr {
              .detail_top_middle {
                margin-left: 10px;
                .date {
                  width: 100px;
                  img {
                    display: none;
                  }
                }
              }
              .detail_top_right {
                margin-left: 10px;
              }
            }
          }
        }
      }
      .all_paper_list {
        ul {
          .all_paper_li {
            width: 25%;
          }
        }
      }
    }
  }
}
</style>